import {
  FETCH_ALERT_SUBSCRIPTION_RESPONSE,
  UPDATE_ALERT_SUBSCRIPTION_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// communityId -> [true]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case FETCH_ALERT_SUBSCRIPTION_RESPONSE:
    case UPDATE_ALERT_SUBSCRIPTION_RESPONSE: {
      const s = { ...state }
      if (action.user.user_id) {
        s[action.id] = action.user.subscribed
      }
      return s
    }

    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
